/** Platform-owner "Pilot Ops" dashboard (internal operator surface). */
export const adminCustomers = {
  title: "Pilot Ops",
  description:
    "Customers, devices, and subscriptions across every workspace.",
  summary: {
    customers: "Customers",
    activeDevices: "Active devices",
    mrr: "Approx. MRR",
    trialsExpiring: "Trials expiring soon",
    revenue: "Revenue (90d)",
  },
  table: {
    business: "Business",
    owner: "Owner",
    status: "Status",
    devices: "Devices",
    revenue: "Revenue",
    trial: "Trial / renews",
    actions: "Actions",
    trialEnds: "Trial ends {date}",
    renews: "Renews {date}",
    devicesSummary: "{active} active / {total} total",
    online: "{count} online",
  },
  /** "estimated" marker shown when Stripe revenue is unavailable and the number is a price-table run-rate. */
  revenueEstimated: "est.",
  detail: {
    open: "Details",
    created: "Created {date}",
    devices: "Devices",
    devicesByStatus: "{online} online · {idle} idle · {offline} offline · {error} error",
    activeDevices: "{count} active (billable)",
    locations: "Locations",
    noLocations: "No locations",
    schedules: "Schedules",
    lastActivity: "Last activity",
    never: "Never",
    subscription: "Subscription",
    noSubscription: "No subscription",
    licenses: "{count} licenses · {interval}ly · {currency}",
    cancelAtPeriodEnd: "Cancels at period end",
    stripeLink: "Open in Stripe",
    deviceLastSeen: "Last seen {date}",
    deviceNeverSeen: "Never seen",
    tickets: "Tickets",
    ticketsSummary: "{open} open · {escalated} escalated",
    recentActivity: "Recent activity",
    noActivity: "No activity recorded",
  },
  status: {
    none: "No subscription",
  },
  action: {
    stripe: "Stripe",
    extendTrial: "Extend trial",
    pilotInvoice: "Create pilot invoice",
  },
  program: {
    label: "Promo program",
    placeholder: "Select a program",
    optionPercent: "{name} ({percent}% off)",
    optionAmount: "{name} ({amount} off)",
  },
  empty: "No customers yet.",
  emptyPrograms: "No active promo programs. Create one via a direct SQL insert (see docs/runbook.md).",
  toast: {
    trialExtended: "Trial extended",
    invoiceCreated: "Pilot invoice sent",
    failed: "Action failed",
  },
} as const;
